import { render, staticRenderFns } from "./BlogDetailsRightSideBarPage.vue?vue&type=template&id=00ba9134&"
import script from "./BlogDetailsRightSideBarPage.vue?vue&type=script&lang=js&"
export * from "./BlogDetailsRightSideBarPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports